import { useMemo as p } from "../external/preact/hooks/dist/hooks.module.js";
import { getLabel as c } from "../components/utils/getLabel.js";
import b from "../core/Context/useCoreContext.js";
import { EMPTY_OBJECT as a } from "../utils/value/constants.js";
import { isUndefined as l, isString as u } from "../utils/value/is.js";
function y(r) {
  let e = {};
  for (const t of Object.keys(r))
    l(r[t]) || (e = { ...e, [t]: r[t] });
  return e;
}
function T(r) {
  return r.every(u);
}
const P = ({
  fields: r,
  customColumns: e,
  columnConfig: t
}) => {
  const { i18n: s } = b(), i = p(() => r.map((o) => ({ key: o })), [r]);
  return p(() => ((e ? T(e) ? e.map((n) => ({ key: n })) : e : void 0) || i).map(({ key: n, flex: f }) => {
    const d = s.get(c(n)), m = y((t == null ? void 0 : t[n]) || a);
    return { key: n, label: d, visible: !0, flex: f, ...m || a };
  }), [t, e, s, i]);
};
export {
  P as useTableColumns
};
